import React from "react";
import { getThemeLogoConfig, hasLogoTextLayout } from "utilities/getThemeLogo";

const DEFAULT_IMG_CLASS = "appLogo";

export const buildLogoImageStyle = ({ logoWidth, logoHeight, useDefaults = true }) => {
  const style = {};
  if (logoWidth) style.width = `${logoWidth}px`;
  if (logoHeight) style.height = `${logoHeight}px`;
  if (!logoWidth && !logoHeight && useDefaults) return {};
  if (logoWidth || logoHeight) {
    style.objectFit = "contain";
    if (!logoWidth) style.width = "auto";
    if (!logoHeight) style.height = "auto";
  }
  return style;
};

export default function ThemeLogo({
  companyId,
  fallbackSrc,
  className = DEFAULT_IMG_CLASS,
  alt = "Company logo",
  previewConfig = null,
}) {
  const config = previewConfig || getThemeLogoConfig(companyId);
  const src = config?.logoUrl || fallbackSrc;
  const showText = hasLogoTextLayout(config);
  const imgStyle = buildLogoImageStyle(config || {});
  const hasCustomSize = Boolean(config?.logoWidth || config?.logoHeight);

  if (!src && !showText) {
    return null;
  }

  if (!showText) {
    return (
      <img
        src={src || fallbackSrc}
        className={hasCustomSize ? undefined : className}
        style={hasCustomSize ? imgStyle : undefined}
        alt={alt}
      />
    );
  }

  return (
    <div
      className="d-flex align-items-center"
      style={{ gap: "12px" }}
      role="img"
      aria-label={alt}
    >
      {src && (
        <img
          src={src}
          alt=""
          style={{
            ...imgStyle,
            ...(hasCustomSize
              ? {}
              : { height: "48px", width: "auto", maxWidth: "80px", objectFit: "contain" }),
          }}
        />
      )}
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}>
        {config.logoNameLine1 && (
          <span
            style={{
              fontFamily: "Work Sans, sans-serif",
              fontWeight: 600,
              fontSize: "18px",
              color: "#0E0E0E",
              whiteSpace: "nowrap",
            }}
          >
            {config.logoNameLine1}
          </span>
        )}
        {config.logoNameLine2 && (
          <span
            style={{
              fontFamily: "Work Sans, sans-serif",
              fontWeight: 500,
              fontSize: "16px",
              color: "#0E0E0E",
              whiteSpace: "nowrap",
            }}
          >
            {config.logoNameLine2}
          </span>
        )}
      </div>
    </div>
  );
}
